import { Box, HStack, Image, Text, Tooltip, VStack } from "@chakra-ui/react";
import React, { useState } from "react";

import { NavLink } from "react-router-dom";
import upArrowIcon from "../../assets/waveflowmain/upArrowIcon.png";
import arrowDownBtn from "../../assets/sidenavbar/arrowDownBtn.png";
export function SidebarTop({ item, isOpen }) {
  return (
    <HStack
      className="link"
      width="90%"
      margin={"auto"}
      boxSizing={"border-box"}
      _hover={{
        bg: "linear-gradient(45deg, rgba(113, 67, 104, 0.5), rgba(50, 51, 55, 1))",

        borderRadius: "7px",
      }}
      transition="all 0.5s"
    >
      <Box as="span">
        <Image src={item.icon} />
      </Box>
      <Text
        display={isOpen ? "block" : "none"}
        fontSize="12px"
        color={"rgba(232, 236, 239, 0.75)"}
      >
        {item.name}
      </Text>
    </HStack>
  );
}

export function HubListComp({ item, isOpen }) {
  return (
    // <Tooltip
    //   // hasArrow
    //   isDisabled={item.name == "Agent Evaluation"}
    //   label={
    //     <Box bg={"black"} borderRadius="md" boxShadow="md">
    //       <Image src={item.img} alt="coming soon" />
    //     </Box>
    //   }
    //   placement="bottom"
    //   bg="transparent"
    //   p={0}
    // >
      <VStack align="start" width="100%">
        <HStack
          style={{ width: "90%" }}
          display="flex"
          justifyContent="space-between"
          margin={"auto"}
          _hover={{
            bg: "linear-gradient(45deg, rgba(113, 67, 104, 0.5), rgba(50, 51, 55, 1))",
            pr: "4px",
            borderRadius: "7px",
            w: "100%",
          }}
        >
          <HStack
            className="link"
            width="80%"
            boxSizing="border-box"
            transition="all 0.5s"
          >
            <Box as="span">
              <Image src={item?.icon} />
            </Box>
            <Text
              color="rgba(232, 236, 239, 0.75)"
              display={isOpen ? "block" : "none"}
              fontSize="12px"
              ml={"40px"}
            >
              {item?.hubname}
            </Text>
          </HStack>
        </HStack>
      </VStack>
    // </Tooltip>
  );
}

export const HubOptionList = ({ ele, isOpen }) => {
  const [asActiveHub, setAsActiveHub] = useState(false);

  return (
    <>
      <HStack
        className="link"
        width="90%"
        margin={"auto"}
        boxSizing={"border-box"}
        _hover={{
          bg: "linear-gradient(45deg, rgba(113, 67, 104, 0.5), rgba(50, 51, 55, 1))",

          borderRadius: "7px",
        }}
        transition="all 0.5s"
        onClick={() => {
          setAsActiveHub(!asActiveHub);
        }}
      >
        <HStack
          className="link"
          width="80%"
          boxSizing="border-box"
          transition="all 0.5s"
        >
          <Box as="span">
            <Image src={ele?.icon} />
          </Box>
          <Text
            display={isOpen ? "block" : "none"}
            fontSize="12px"
            color={"rgba(232, 236, 239, 0.75)"}
          >
            {ele?.name}
          </Text>
        </HStack>
        <Box display={isOpen ? "block" : "none"} marginLeft="auto" p={1}>
          <Image src={asActiveHub ?  upArrowIcon : arrowDownBtn} />
        </Box>
      </HStack>
      {asActiveHub && ele?.hubList && (
        <Box>
          <VStack align="start">
            {ele?.hubList.map((item, index) => (
              <NavLink
                // isDisabled={item.path==""}
                to={item.path == "" ? "#" : item.path}
                key={index}
                style={{ width: "100%" }}
              >
                <HubListComp item={item} isOpen={isOpen} />
              </NavLink>
            ))}
          </VStack>
        </Box>
      )}
    </>
  );
};

export const AgentInAction = ({ item, index, isOpen }) => {
  return (
    <NavLink
      // isDisabled={item.path==""}
      to={item.path == "" ? "#" : item.path}
      key={index}
      style={{ width: "100%" }}
    >
      <Tooltip
        // hasArrow
        isDisabled={item?.name =="AI Observability"}
        label={
          <Box bg={"black"} borderRadius="md" boxShadow="md">
            <Image src={item.img} alt="coming soon" />
          </Box>
        }
        placement="bottom"
        bg="transparent"
        p={0}
      >
        <VStack align="start" width="100%">
          <HStack
            style={{ width: "90%" }}
            display="flex"
            justifyContent="space-between"
            margin={"auto"}
            _hover={{
              bg: "linear-gradient(45deg, rgba(113, 67, 104, 0.5), rgba(50, 51, 55, 1))",
              pr: "4px",
              borderRadius: "7px",
              w: "100%",
            }}
          >
            <HStack
              className="link"
              width="80%"
              boxSizing="border-box"
              transition="all 0.5s"
            >
              <Box as="span">
                <Image src={item.icon} />
              </Box>
              <Text
                color="rgba(232, 236, 239, 0.75)"
                display={isOpen ? "block" : "none"}
                fontSize="12px"
              >
                {item.name}
              </Text>
            </HStack>
          </HStack>
        </VStack>
      </Tooltip>
    </NavLink>
  );
};
